export default "__VITE_ASSET__CQtc2msG__"